import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, IconButton, MenuItem, Select } from '@mui/material';
import { useUpdateCategoryMutation } from 'App/services/categoryServiceApi';
import { useUpdateProviderMutation } from 'App/services/providerServiceApi';
import { toast } from 'react-toastify';

export default function ProviderEditFormDialog({ provider }) {

  const [open, setOpen] = useState(false);

  const [providerName, setProviderName] = React.useState(provider.name);
  const [adsStatus, setAdsStatus] = React.useState(provider.adStatus);

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);  
  };


  const handleClose = () => {
    setOpen(false);
  };

  const [updateProvider, { isLoading, isError, error }] = useUpdateProviderMutation();

  const handleEditProvider = async (event) => {
    event.preventDefault();
    try {

      if(providerName){
        await updateProvider( {id: provider.id, name: providerName, adStatus:adsStatus} );
        toast.success("Provider Successfully Updated!");
        handleClose();
        }
        else{
          toast.error("Required to Provider Field name");
    
        }
    } catch (error) {
      toast.error("Something went Wrong!!")
    }
    
  };

  return (
    <React.Fragment>

       <IconButton onClick={handleClickOpen}>
        <Icon>edit</Icon>
      </IconButton>
   
     
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleEditProvider,
        }}
      >
        <DialogTitle>Edit Provider</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the name of the Provider:
          </DialogContentText>
          <TextField
            autoFocus
            // required
            margin="dense"
            id="name"
            name='name'
            label="Provider Name"
            type="text"
            fullWidth
            defaultValue={providerName}
            onChange={(e) => setProviderName(e.target.value)}
            error={!!error}
            helperText={error ? error.message : ""}
            disabled
          />
            <Select
            // required
            fullWidth
            sx={{ height: 40, mt: 2 }}
            defaultValue={adsStatus}
            onChange={(e) => setAdsStatus(e.target.value)}
            displayEmpty
          >
            <MenuItem value={1}>Active</MenuItem>
            <MenuItem value={0}>InActive</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" name="submit">Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
